import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore, { DEFAULT_PASSWORD } from '../../../../stores/authStore';
import styles from './LoginForm.module.css';

/**
 * 사업자등록번호 포맷팅 (123-45-67890)
 */
const formatBusinessNumber = value => {
  const numbers = value.replace(/[^0-9]/g, '');
  if (numbers.length <= 3) {
    return numbers;
  } else if (numbers.length <= 5) {
    return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
  } else {
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 5)}-${numbers.slice(5, 10)}`;
  }
};

/**
 * LoginForm Component
 * 약국 로그인 폼 컴포넌트
 */
const LoginForm = () => {
  const [businessNumber, setBusinessNumber] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const login = useAuthStore(state => state.login);
  const isLoading = useAuthStore(state => state.isLoading);

  const handleBusinessNumberChange = e => {
    const formatted = formatBusinessNumber(e.target.value);
    setBusinessNumber(formatted);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');

    // 사업자등록번호에서 하이픈 제거
    const cleanBusinessNumber = businessNumber.replace(/-/g, '');

    if (cleanBusinessNumber.length !== 10) {
      setError('사업자등록번호 10자리를 입력해주세요.');
      return;
    }

    if (!password) {
      setError('비밀번호를 입력해주세요.');
      return;
    }

    try {
      const result = await login(businessNumber, password);

      if (result.success) {
        // 기본 비밀번호인 경우 비밀번호 변경 화면으로
        if (password === DEFAULT_PASSWORD) {
          navigate('/change-password');
        } else {
          navigate('/dashboard/home');
        }
      } else {
        // 비밀번호가 설정되지 않은 경우 비밀번호 설정 화면으로 이동
        if (result.error?.includes('비밀번호가 설정되지 않았습니다')) {
          navigate('/change-password', {
            state: { businessNumber: businessNumber },
          });
        } else {
          setError(result.error || '로그인에 실패했습니다.');
        }
      }
    } catch (err) {
      setError('로그인 중 오류가 발생했습니다.');
    }
  };

  return (
    <div className={styles.container}>
      <form className={styles.form} onSubmit={handleSubmit}>
        <img
          src="/images/logo-pharmview-v2.png"
          alt="PharmView"
          className={styles.logo}
        />

        <div className={styles.divider} />

        <h3 className={styles.title}>약국 로그인</h3>

        {error && <div className={styles.error}>{error}</div>}

        <div className={styles.inputGroup}>
          <label htmlFor="businessNumber">사업자등록번호</label>
          <input
            id="businessNumber"
            type="text"
            placeholder="123-45-67890"
            value={businessNumber}
            onChange={handleBusinessNumberChange}
            maxLength={12}
            required
          />
        </div>

        <div className={styles.inputGroup}>
          <label htmlFor="password">비밀번호</label>
          <input
            id="password"
            type="password"
            placeholder="비밀번호를 입력하세요"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit" disabled={isLoading}>
          {isLoading ? '로그인 중...' : '로그인'}
        </button>

      </form>
    </div>
  );
};

export default LoginForm;
